import { gql } from '@apollo/client'
import { WHOLE_AUDIT_FRAGMENT } from '../fragments'

export const GET_STORE_AUDIT = gql`
  query GetStoreAudit($auditId: ID!) {
    audit(auditId: $auditId) {
      ...WholeAudit
    }
  }
  ${WHOLE_AUDIT_FRAGMENT}
`
